import React, { useState } from 'react';
import styled from 'styled-components';
import Button from '~~elements/Button';
import { COLOR } from '~~elements/Const';
import { TABLET_WIDTH } from '~~elements/Const';
import { PlayerResource } from '~~apis/resource';
import TTMultilingual from './Multilingual';
import { useTournamentState } from '../useTournament';

const StyledDiv = styled.div`
  position: fixed;
  width: 25rem;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background: ${COLOR.secondary};
  border-radius: 10px;
  border: 1px solid gray;
  color: white;
  z-index: 10;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .player-delete {
    &--title {
      margin-bottom: 0.5rem;
      text-align: center;
      font-size: 1.1rem;
    }
    &--warning {
      color: ${COLOR.primary};
      text-align: center;
      font-size: 1rem;
    }
    &--control {
      margin-top: 1rem;
      display: flex;
      justify-content: center;
    }
  }

  @media (max-width: ${TABLET_WIDTH}) {
    width: 95vw;
    padding: 1rem;
    .player-delete {
      &--title {
        font-size: 1rem;
      }
      &--warning {
        font-size: 0.8rem;
      }
      &--control {
        margin-top: 0.8rem;
      }
    }
  }
`;

const PlayerDelete = ({ playerState, playerDispatch, seasonUniqid, seasonTeamUniqid, done }) => {
  const { organizerUniqid } = useTournamentState();
  const [success, setSuccess] = useState(false);

  const handleCancel = () => {
    playerDispatch({ type: 'reset' });
  };

  const handleDelete = () => {
    PlayerResource.deletePlayerInSeasonTeamByOrganizer({
      leagueUniqid: organizerUniqid,
      seasonUniqid,
      seasonTeamUniqid,
      playerNumber: playerState.number,
    })
      .then(() => {
        setSuccess(true);
        setTimeout(() => done(), 500);
      })
      .catch(() => {
        playerDispatch({ type: 'error', payload: TTMultilingual(`COMMON.UNKNOWN_ERROR`) });
      });
  };

  return (
    <StyledDiv>
      <div className="player-delete--title">
        {`${TTMultilingual(`DELETE_PLAYER`)} ${playerState.name} #${playerState.number}`}
      </div>
      {playerState.joined_game && (
        <div className="player-delete--warning">{TTMultilingual(`JOINED_AND_DELETE_DENY`)}</div>
      )}
      {playerState.errorMsg && <div className="registration--error-msg">{playerState.errorMsg}</div>}
      {success && <div className="registration--success-msg">{TTMultilingual(`SUCCESS.DELETE`)}</div>}
      <div className="player-delete--control">
        {playerState.joined_game ? (
          <Button width="unset" color="white" onClick={handleCancel}>
            {TTMultilingual(`COMMON.CLOSE`)}
          </Button>
        ) : (
          <>
            <Button width="unset" color="red" onClick={handleDelete}>
              {TTMultilingual(`COMMON.DELETE_CONFIRM`)}
            </Button>
            <Button width="unset" color="white" onClick={handleCancel}>
              {TTMultilingual(`COMMON.CANCEL`)}
            </Button>
          </>
        )}
      </div>
    </StyledDiv>
  );
};

export default PlayerDelete;
